import { useCallback } from "react";

import { useSalesDriversStore } from "../store/useSalesDriversStore";

export const useFilterActions = () => {
  const {
    filters: { activeFilterIds, expandedSectionIds },
    setActiveFilterIds,
    setExpandedSectionIds,
  } = useSalesDriversStore();

  const toggleSection = useCallback(
    (sectionId: string) => {
      setExpandedSectionIds(
        expandedSectionIds.includes(sectionId)
          ? expandedSectionIds.filter((id) => id !== sectionId)
          : [...expandedSectionIds, sectionId]
      );
    },
    [expandedSectionIds, setExpandedSectionIds]
  );

  const toggleItem = useCallback(
    (itemId: string) => {
      setActiveFilterIds(
        activeFilterIds.includes(itemId)
          ? activeFilterIds.filter((id) => id !== itemId)
          : [...activeFilterIds, itemId]
      );
    },
    [activeFilterIds, setActiveFilterIds]
  );

  const resetFilters = useCallback(
    (allSections: string[], allItems: string[]) => {
      setExpandedSectionIds(allSections);
      setActiveFilterIds(allItems);
    },
    [setExpandedSectionIds, setActiveFilterIds]
  );

  const showOnlySection = useCallback(
    (sectionId: string, itemIds: string[]) => {
      setActiveFilterIds(itemIds);
      setExpandedSectionIds([sectionId]);
    },
    [setActiveFilterIds, setExpandedSectionIds]
  );

  const hideAllSection = useCallback(
    (sectionId: string, itemIds: string[], showAll: boolean) => {
      if (showAll) {
        setActiveFilterIds(Array.from(new Set([...activeFilterIds, ...itemIds])));
        setExpandedSectionIds(
          !expandedSectionIds.includes(sectionId)
            ? [...expandedSectionIds, sectionId]
            : expandedSectionIds
        );
      } else {
        setActiveFilterIds(activeFilterIds.filter((id) => !itemIds.includes(id)));
        setExpandedSectionIds(expandedSectionIds.filter((id) => id !== sectionId));
      }
    },
    [activeFilterIds, expandedSectionIds, setActiveFilterIds, setExpandedSectionIds]
  );

  return {
    activeFilterIds,
    expandedSectionIds,
    toggleSection,
    toggleItem,
    resetFilters,
    showOnlySection,
    hideAllSection,
  };
};
